export enum GAEventAction {
    Click = 'click',
    NoResults = 'no-results',
    PWAInstalled = 'Installed PWA',
    PWAInstallClicked = 'Install PWA clicked',
    PWAInstallBannerShown = 'Install PWA banner shown',
    PWASubscribeBannerShown = 'Subscribe to notifications banner shown',
    PWASubscribeBannerDismissed = 'Subscribe to notifications banner dismissed',
    PWAInstallBannerDismissed = 'Install PWA banner dismissed',
    PWAPermissionRequest = 'Notifications permissions prompt triggered',
    PWAPermissionsChanged = 'User changed notifications permissions',
    PWASubscribeToNotificationsClicked = 'Subscribe to notifications clicked',
    TicketShare = 'digital-ticket-share',
    TicketRevoke = 'digital-ticket-revoke',
    AddFanReportSubmit = 'add-fan-report-submit',
    ArtistSearch = 'artist-search',
    FirstPageSubscription = 'first-page-subscription',
    FirstPageFooterSubscription = 'first-page-footer-subscription',
    LandscapePromotionNewsletter = 'landscape-promotion-newsletter',
    FilterApply = 'filter-apply',
    FilterRemove = 'filter-remove'
}
